import Image from "next/image";

import { renderTemplate } from "@repo/ui/components/common/cms";
import { isFullFlexBundle, isSmartBundle } from "@repo/ui/constants/bundleCodes";
import type { BoardingPassSection, PriorityBoardingSection } from "@repo/ui/types/cms";

import TravelPackInfoCard from "./TravelPackInfoCard";

interface TravelPackInfoCardRendererProps {
  bundleCode?: string;
  disabled: boolean;
  InBundleInAnyJourney?: boolean;
  cmsData?: BoardingPassSection | PriorityBoardingSection;
}

export const TravelPackInfoCardRenderer = ({
  bundleCode,
  InBundleInAnyJourney,
  cmsData,
}: Readonly<TravelPackInfoCardRendererProps>) => {
  if (isSmartBundle(bundleCode)) {
    return (
      <TravelPackInfoCard variant="cyanIncluded">
        {renderTemplate(cmsData?.packSmartLabel ?? "", {
          packSmartIcon: (
            <Image
              src={cmsData?.packSmartIcon ?? ""}
              width={80}
              height={35}
              alt="Pack Smart"
              className="inline-block"
            />
          ),
        })}
      </TravelPackInfoCard>
    );
  }

  if (isFullFlexBundle(bundleCode)) {
    return (
      <TravelPackInfoCard variant="blueIncluded">
        {renderTemplate(cmsData?.packFullLabel ?? "", {
          packFullIcon: (
            <Image
              src={cmsData?.packFullIcon ?? ""}
              width={80}
              height={35}
              alt="Pack Full"
              className="inline-block"
            />
          ),
        })}
      </TravelPackInfoCard>
    );
  }

  if (InBundleInAnyJourney) {
    return <div className="h-7" />;
  }

  return null;
};

export default TravelPackInfoCardRenderer;
